module.exports = __webpack_public_path__ + "img/1.5f7e6d62.png";